
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/create",
      function () {
        return require("private-next-pages/order/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/create"])
      });
    }
  